import { goURL } from '../../../webmodule-common/other/ui/resource-resolver';

export const resourceFabricationPurchaseOrder = 'fabricationPurchaseOrder';
export async function launchFabricationPurchaseOrder(id: string) {
  goURL(resourceFabricationPurchaseOrder, id);
  return true;
}
